import axiosInstance from '../axiosInstance';

const getConfig = async (workspaceId) => {
  return axiosInstance.get(`/ai/config/${workspaceId}`).then((response) => {
    return response.data;
  });
};

const updateConfig = async (workspaceId, config) => {
  return axiosInstance.put(`/ai/config/${workspaceId}`, config).then((response) => {
    return response.data;
  });
};

// Whether the current workspace has an assistant, which is all a non-superuser
// may read of the config; scoped by the x-workspace-id header like the
// conversations below, so it never names a workspace.
const getStatus = async () => {
  return axiosInstance.get('/ai/status').then((response) => {
    return response.data;
  });
};

const getAllWorkspaces = async () => {
  return axiosInstance.get('/workspace/all').then((response) => {
    return response.data;
  });
};

// The sidebar's chat history: conversations are scoped to the workspace the
// axios instance sends in the x-workspace-id header, so these calls never
// name one.

const listConversations = async () => {
  return axiosInstance.get('/ai/conversations').then((response) => {
    return response.data;
  });
};

const createConversation = async (title = '') => {
  return axiosInstance.post('/ai/conversations', { title }).then((response) => {
    return response.data;
  });
};

const getConversation = async (id) => {
  return axiosInstance.get(`/ai/conversations/${id}`).then((response) => {
    return response.data;
  });
};

const saveConversation = async (id, payload) => {
  return axiosInstance.put(`/ai/conversations/${id}`, payload).then((response) => {
    return response.data;
  });
};

const deleteConversation = async (id) => {
  return axiosInstance.delete(`/ai/conversations/${id}`).then((response) => {
    return response.data;
  });
};

const aiService = {
  getConfig,
  updateConfig,
  getStatus,
  getAllWorkspaces,
  listConversations,
  createConversation,
  getConversation,
  saveConversation,
  deleteConversation
};

export default aiService;
